/**
=========================================================
* Trakib - v2.1.0
=========================================================

* Product Page: https://www.trakib.com/product/material-dashboard-pro-react
* Copyright 2022 Trakib (https://www.trakib.com)

Coded by www.trakib.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Trakib Base Styles
// Trakib Base Styles
import colors from "assets/theme/base/colors";

// Fonts
import DINNextArabicRegular from "assets/fonts/DINNextArabic-Regular.otf";
import DINNextArabicMedium from "assets/fonts/DINNextArabic-Medium.otf";
import DINNextArabicBold from "assets/fonts/DINNextArabic-Bold.otf";
import DINNextArabicLight from "assets/fonts/DINNextArabic-Light.otf";
import DINNextArabicBlack from "assets/fonts/DINNextArabic-Black.otf";
import DINNextArabicHeavy from "assets/fonts/DINNextArabic-Heavy.otf";
import DINNextArabicUltralight from "assets/fonts/DINNextArabic-Ultralight.otf";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "@font-face": [
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicRegular}) format("opentype")`,
      weight: 400,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicMedium}) format("opentype")`,
      weight: 500,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicBold}) format("opentype")`,
      weight: 700,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicLight}) format("opentype")`,
      weight: 300,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicBlack}) format("opentype")`,
      weight: 900,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicHeavy}) format("opentype")`,
      weight: 800,
      fontStyle: "normal",
    },
    {
      fontFamily: "DINNextArabic",
      src: `url(${DINNextArabicUltralight}) format("opentype")`,
      weight: 100,
      fontStyle: "normal",
    },
  ],
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
};

export default globals;
